// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__uSWho","LeftText":"Footer_LeftText__XDixd","RightContent":"Footer_RightContent__nO89B","List":"Footer_List__Jzbpm"};